import {getUrl} from "@addon-core/browser";

import {PageConfig, PageDefinition, PageProps} from "@typing/page";

export type {PageDefinition, PageProps, PageConfig};

export type PageAlias = string;

export type PageMap = Map<PageAlias, string>;

export const definePage = (options: PageDefinition): PageDefinition => {
    return options;
};

export const getPages = (): PageMap => {
    const pages: PageMap = new Map();

    try {
        // @ts-expect-error: __ADNBN_PAGE_ALIAS__ is a virtual variable generated by the bundler `src/cli/plugins/page/index.ts`
        Object.entries<string>(__ADNBN_PAGE_ALIAS__).forEach(([key, value]) => {
            pages.set(key, value);
        });
    } catch (e) {
        console.error("Failed getting pages: ", e);
    }

    return pages;
};

export const getPageUrl = (alias: PageAlias): string => {
    let path = getPages().get(alias);

    if (!path) {
        console.warn(`Cannot find page: ${alias}`);

        path = alias;
    }

    return getUrl(path);
};
